import { createContext, useEffect, useState, useContext } from 'react';
import { db, db1, ref, onValue, getDocs, collection, addDoc, auth, onAuthStateChanged } from 'config/Firebase'

const DataContext = createContext();

const DataContextProvider = ({ children }) => {
    const [user, setUser] = useState({ isAuth: false, isLoading: true, data: {} });
    const [data, setData] = useState({
        loaded: false,
        fiverr: {
            proposal: "",
            links: {}
        },
        upWork: { links: [] },
        reactjs: { links: [] },
        landing_pages: { links: [] },
        javascript: { links: [] },
        frontend: { links: [] },
        responsive: { links: [] },
        game: { links: [] },
        backend: { links: [] },
        nft: { links: [] },
    });

    useEffect(() => {
        const getData = async () => {
            // get records
            const storeRef = ref(db, '/store');
            onValue(storeRef, (snapshot) => {
                const dbData = snapshot.val();
                setData({ ...data, ...dbData, loaded: true });
            });
            // user
            onAuthStateChanged(auth, (user_) => {
                if (user_) {
                    setUser({ isAuth: true, isLoading: false, user: user_ })
                } else {
                    setUser({ isAuth: false, isLoading: false, user: {} })
                }
            });

            // ======== realtime old we are using
            // const storeRef1 = ref(db, '/blogs');
            // onValue(storeRef1, (snapshot) => {
            //     const dbData1 = snapshot.val();
            //     console.log(dbData1)
            // });


            // ===============
            // const querySnapshot = await getDocs(collection(db1, "/blogs"));
            // querySnapshot.forEach((doc) => {
            //   console.log(doc.id, " => ", doc.data());
            // });

        };
        getData();

        return getData();
    }, []);

    // ======== ignore =========
    // const addData = async () => {
    //     try {
    //         const docRef = await addDoc(collection(db1, "/blogs"), 
    //          {

    //          }
    //         );
    //         console.log("Document written with ID: ", docRef.id);
    //       } catch (e) {
    //         console.error("Error adding document: ", e);
    //       }
    // }

    return (
        <DataContext.Provider value={{ data: data, user }}>
            {/* <button onClick={addData}>Add +</button> */}
            {children}
        </DataContext.Provider>
    )
};

export const useData = () => useContext(DataContext);

export default DataContextProvider;

